import { Mail, Calendar } from "lucide-react";
import { SITE } from "@/lib/site";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-brand-sage/20 bg-brand-cream"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20 grid md:grid-cols-12 gap-10 md:gap-12">
        <div className="md:col-span-5">
          <a href="#top" className="inline-block isolate bg-brand-cream">
            <img
              src={SITE.logoUrl}
              alt="Noa Grant Coaching — Parent and ADHD Coach"
              className="h-24 md:h-28 w-auto object-contain"
              style={{ mixBlendMode: "darken" }}
            />
          </a>
          <p className="mt-6 max-w-md text-base text-brand-navy/70 leading-relaxed">
            Coaching for ADHD brains. Turning strengths into systems that
            actually work, for adults, students, and the parents who love them.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-[0.22em] text-brand-coral font-semibold">
            Explore
          </div>
          <ul className="mt-5 space-y-3 text-base text-brand-navy/80">
            <li><a href="#what-is-coaching" className="link-sweep">Coaching</a></li>
            <li><a href="#services" className="link-sweep">Services</a></li>
            <li><a href="#about" className="link-sweep">About</a></li>
            <li><a href="#faq" className="link-sweep">FAQ</a></li>
            <li><a href="#contact" className="link-sweep">Contact</a></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-xs uppercase tracking-[0.22em] text-brand-coral font-semibold">
            Get in touch
          </div>
          <ul className="mt-5 space-y-4 text-base text-brand-navy/80">
            <li>
              <a
                href={`mailto:${SITE.email}`}
                data-testid="footer-email"
                className="inline-flex items-center gap-3 hover:text-brand-coral transition"
              >
                <Mail size={16} />
                {SITE.email}
              </a>
            </li>
            <li>
              <a
                href={SITE.calendly}
                target="_blank"
                rel="noreferrer noopener"
                data-testid="footer-calendly"
                className="inline-flex items-center gap-3 hover:text-brand-coral transition"
              >
                <Calendar size={16} />
                Book a Discovery Call
              </a>
            </li>
          </ul>

          <div className="mt-8 pt-6 border-t border-brand-sage/20">
            <div className="text-xs uppercase tracking-[0.22em] text-brand-sage font-semibold mb-3">
              Accreditation
            </div>
            <a
              href="https://addca.com/"
              target="_blank"
              rel="noreferrer noopener"
              data-testid="footer-addca"
              className="inline-flex items-center gap-3 group"
              aria-label="ADDCA Accredited ADHD & Life Coach Training Program"
            >
              <img
                src={SITE.addcaLogoUrl}
                alt="ADDCA — Accredited ADHD & Life Coach Training Program"
                className="h-16 md:h-20 w-auto rounded-lg shadow-sm group-hover:shadow-md transition-shadow"
              />
              <span className="text-sm text-brand-navy/70 leading-snug max-w-[160px]">
                Accredited ADHD &amp; Life Coach training
              </span>
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-brand-sage/20">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-sm text-brand-navy/60">
          <div>© {year} Noa Grant Coaching. All rights reserved.</div>
          <div className="font-serif italic text-brand-sageDeep">
            "Turn stuck into unstoppable."
          </div>
        </div>
      </div>
    </footer>
  );
}
